<template>
  <div class="rodemap">
    <div class="mask05"></div>
    <QuestionSelect :data="data" @jump="jump" @finish="finish"></QuestionSelect>
  </div>
</template>

<script>
//script
import Tools from '../../../scripts/tools';
import { gsap } from 'gsap';
//Global
import Global from '../../../scripts/Global';

import QuestionSelect from '../../cmp/questionSelect';

export default {
  data() {
    return {
      data: {
        // headTipImg: '乔诗语讲解',
        headTipTxt: '选中当然是留牌子了，没有选中的会撂牌子。',
        headTipPathTxt: '前往承光门 >>',
        headTipPath: '/rodemap/qsy/03',
        
        sideImg: '乔诗语',
        sideCfg: {
          top: '-3.3rem',
          left: '-1.2rem',
          transform: 'scale(0.5)',
        },
        qText: '快来看，马上要选秀女了！你知道怎样算是选中了吗？',
        errText: '快来看，马上要选秀女了！你知道怎样算是选中了吗？',
        okText: '快来看，马上要选秀女了！你知道怎样算是选中了吗？',

        answerArr: [
          {
            txt: '留牌子',
            right: true,
          },
          {
            txt: '撂牌子',
          },
        ],
      },
    };
  },
  components: {
    QuestionSelect,
  },
  created() {
    Global.startPlay('qsy', 'scene2_1');
  },
  computed: {},
  methods: {
    jump(event) {
      if (event) {
      } else {
        this.$router.replace('/rodemap/qsy/03');
      }
      console.log(event, 'event');
    },
    finish(event) {
      if (event) {
        Global.curr = {
          ...this.data,
          headTipImg: '',
          headTipTxt: '',
          headTipPath: '/rodemap/qsy/03',
          headTipPathTxt: '前往承光门 >>',
          ybtxt:
            '清代入宫的女子有两种：一种叫秀女，一种叫宫女子。秀女系八旗官员的女儿，地位较高；宫女子是内务府包衣佐领下的女儿，地位比较低。',
          bg: '顺贞门',
        };
        Global.yubi.qsy.b1 = true;
        this.$router.replace('/yu');
        Global.startPlay('qsy', 'scene3');
      } else {
        Global.startPlay('qsy', 'scene4');
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.rodemap {
  background-image: url(//cdn.original-fun.com/gugong/顺贞门.jpg);
  background-position: center;
  width: 100vw;
  height: 100vh;
  max-width: 75vh;
  margin: 0 auto;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
